/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

export const selectItemsFieldName = [
  {
    key: 'reasonWonLostValues',
    value: null,
    details: null
  },
  {
    key: 'industryTypeValue',
    value: null,
    details: null
  },
  {
    key: 'globalAccountTypes',
    value: null,
    details: null
  },
  {
    key: 'needs',
    value: null,
    details: null
  },
  {
    key: 'salesChannels',
    value: null,
    details: null
  },
  {
    key: 'revenueBrands',
    value: null,
    details: null
  },
  {
    key: 'gpBrands',
    value: null,
    details: null
  },
  {
    key: 'serviceTypeValue',
    value: null,
    details: null
  },
  {
    key: 'trafficChannelTypeValue',
    value: null,
    details: null
  },
  {
    key: 'shipmentType',
    value: null,
    details: null
  },
  {
    key: 'incotermValue',
    value: null,
    details: null
  },
  {
    key: 'volumeUnitValue',
    value: null,
    details: null
  },
  {
    key: 'weightUnitValue',
    value: null,
    details: null
  },

  {
    key: 'contactTypeValue',
    value: null,
    details: null
  },

  {
    key: 'buyingRoleValue',
    value: null,
    details: null
  },

  {
    key: 'jobTitleValue',
    value: null,
    details: null
  },

  {
    key: 'activityType',
    value: null,
    details: null
  },

  {
    key: 'activityObjective',
    value: null,
    details: null
  },

  {
    key: 'activityPurpose',
    value: null,
    details: null
  },
  {
    key: 'activityOutcome',
    value: null,
    details: null
  },
  {
    key: 'callFrequency',
    value: null,
    details: null
  },
  {
    key: 'vehicleType',
    value: null,
    details: null
  },
  {
    key: 'offerRefuseReason',
    value: null,
    details: null
  },
  {
    key: 'invoiceOperationType',
    value: null,
    details: null
  },
  {
    key: 'documentType',
    value: null,
    details: null
  },
  {
    key: 'activeUserType',
    value: null,
    details: null
  }
];
